import { EmailDeliverabilityKpisOutDto } from '@app/swagger-types';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

import { EmailKpiTile } from '../../shared/EmailKpiTile';

// admin-emailbeheer blok B (opdracht §7). suppressionListSize is the one list-side number
// among delivery-side counts - opdracht: "laat het verschil zien tussen een lijstprobleem en
// een bezorgprobleem."
export const EmailDeliverabilityKpiCards: React.FC<{ kpis: EmailDeliverabilityKpisOutDto }> = ({ kpis }) => {
  return (
    <div className="grid grid-cols-2 gap-3 md:grid-cols-6">
      <EmailKpiTile label="Bounce (hard)" value={kpis.bouncedHard.toLocaleString()} foot="address doesn't exist" />
      <EmailKpiTile label="Blocked (soft)" value={kpis.blocked.toLocaleString()} foot="temporarily refused" />
      <EmailKpiTile label="Deferred" value={kpis.deferred.toLocaleString()} foot="SendGrid is retrying" />
      <EmailKpiTile
        label="Dropped"
        value={kpis.dropped.toLocaleString()}
        status={{ tone: 'warn', icon: <WarningAmberIcon sx={{ fontSize: 13 }} />, text: 'held back by SendGrid' }}
      />
      <EmailKpiTile label="Complaints" value={kpis.complained.toLocaleString()} />
      <EmailKpiTile
        label="Suppression list"
        value={kpis.suppressionListSize.toLocaleString()}
        foot="ours + SendGrid, deduped"
      />
    </div>
  );
};
